   
import { Component, OnInit, Inject } from "@angular/core";
import { FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { OrganizationService } from "src/app/Service/organization/organization.service";
import { IOrganizationViewModel } from "src/app/ViewModel/OrganizationModel";
import { ExternalMemberService } from 'src/app/Service/member/external-member.service';
import { NotificationService } from 'src/app/Service/notification.service';
import { StandardOutputModel } from 'src/app/ViewModel/StandardOutputModel';
import { IDeleteDocumentInputModel,  DrawingInactiveOutputModel, DrawingInactiveInputModel } from 'src/app/ViewModel/DeletedocumentModel';
import { CommonService } from 'src/app/Service/Common.service';
import { DeleteDocumentService } from 'src/app/Service/deletedocument/deletedocument.service';

@Component({
  selector: 'app-Drawing-Inactive-Response',
  templateUrl: './Drawing-Inactive-Response.components.html',
  styleUrls: ['./Drawing-Inactive-Response.components.css']
})
export class DrawingInactiveResponseComponent implements OnInit {
  enableFilter = false;
  enableFullscreen = false;
  projectId!:number;
  groupId !:number;
  LoggedInUserGroupId!:number;
  LoggedInUserId!:number;
  public Search:string="Search";
  public update_status!:string;
  DrawingForm!: FormGroup;
  businessGroups: IOrganizationViewModel[] = [];
  RevisionType : string ="1";
  public pageSize = [50, 100, 200, {
    text: 'All',
    value: 'all'
  }];
  /**Members list against the business group */
  public DocumentList: DrawingInactiveOutputModel[] = [];
  constructor(public _dialogRef: MatDialogRef<DrawingInactiveResponseComponent>, @Inject(MAT_DIALOG_DATA) public data: any,private _dialog: MatDialog, private _orgService: OrganizationService, public _formBuilder: FormBuilder,
    private _extMemberService: ExternalMemberService, private _notificationService: NotificationService, public commonService: CommonService,
    public DeleteDocumentService : DeleteDocumentService) {
      if (this.data ) {
       this.DocumentList=this.data
      }

  }
  ngOnInit() {
    this.createBusinessGroupForm();
   
  }

  createBusinessGroupForm() {
    this.DrawingForm = this._formBuilder.group({
      businessGroup: new FormControl('', [Validators.required]),
      Documet_no: new FormControl(),
      Documet_title : new FormControl(),
      DocumentStatus: new FormControl(true),

    })
  }

  

  /**
  * Get organization list
  */
 


 


  
 
  
  handleHeaderCheckboxEvent(event : any)
  {
    this.DocumentList.map(x=>x.is_select=event.checked)
  }
  
   /**
* Toggle filter
*/
  toggleFilter() {
    this.enableFilter = !this.enableFilter;
  }

  /**
     * Full screen
     */
  toggleFullscreen() {
    this.enableFullscreen = !this.enableFullscreen;
  }
  closeDialog() {
    this._dialogRef.close();
  }
  getFormValue(controlName: string): any {
    return this.DrawingForm.get(controlName)?.value;
}
 
}
